const validCloudOrigins = [
    'plt-nst-tms-we-01-apim.azure-api.net',
    'alpha.uipath.com',
    'staging.uipath.com',
    'cloud.uipath.com',
    'staging.gov.uipath-dev.com',
    'alpha.gov.uipath-dev.com',
    'govcloud.uipath.us',
];

export function getIdentityAuthority(isMsi?: boolean) {
    // allow overriding authority from environment variables for local
    const host = window.location.host;

    if (validCloudOrigins.includes(host)) {
        return `https://${host}/identity_`;
    }

    const identityPath = isMsi ? 'identity' : 'identity_';

    return `https://${host}/${identityPath}`;
}

